const timelineItems = [
  {
    year: "2004",
    title: "Kuruluş",
    desc: "Genel müteahhitlik firması olarak Türkiye'de faaliyete başlandı.",
    active: false,
  },
  {
    year: "2015",
    title: "Büyük Ölçekli Projeler",
    desc: "TEİAŞ GIS ve enerji altyapısı projelerinde uzmanlaşma süreci başladı.",
    active: false,
  },
  {
    year: "2020",
    title: "Türkiye Geneline Yayılım",
    desc: "Farklı illerde eş zamanlı projelerle ulusal ölçekte hizmet verilmeye başlandı.",
    active: false,
  },
  {
    year: "Bugün",
    title: "Güvenilir Çözüm Ortağı",
    desc: "33+ tamamlanan proje ve uzman kadrosuyla büyümeye devam ediyor.",
    active: true,
  },
];

export default function AboutSection() {
  return (
    <section id="hakkimizda" className="bg-white py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          {/* Left */}
          <div className="lg:w-5/12">
            <span className="text-[#4CAF50] text-sm font-semibold uppercase tracking-widest mb-3 block">
              Hakkımızda
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1A2B4A] leading-tight mb-4">
              Güvenden<br />Güvenli Dizayn'a
            </h2>
            <div className="w-12 h-0.5 bg-[#4CAF50] mb-6" />
            <p className="text-[#4A5568] text-base leading-relaxed mb-5">
              Güvenli Dizayn Dekorasyon ve İnşaat Tic. Ltd. Şti., 2004 yılında Türkiye'de genel müteahhitlik firması olarak kurulmuş; faaliyetinin başlangıcından bu yana büyük çaplı birçok projeye imza atmıştır.
            </p>
            <p className="text-[#4A5568] text-base leading-relaxed mb-5">
              Köklü kurumlarla yürütülen projeler, firmamızın kalite ve güvenilirlik anlayışının somut kanıtlarıdır. Uzman mühendis kadromuz ile anahtar teslimi projelerde tasarımdan teslimata kesintisiz hizmet sunmaktayız.
            </p>
            <p className="text-[#4A5568] text-base leading-relaxed mb-8">
              GİS TM Projeleri — 380 kV-154 kV şalt projeleri kapsamında Metal Clad, kumanda binaları, CAF ve güvenlik binalarına ait ince işler, kaba işler; mimari uygulamalar, peyzaj düzenlemeleri ile elektrik, mekanik tesisat ve altyapı çözümlerinin projelendirme ve uygulama süreçleri entegre mühendislik yaklaşımıyla yürütülmektedir.
            </p>
            <div className="inline-flex items-center gap-3 bg-[#4CAF50]/10 border border-[#4CAF50]/30 rounded-xl px-5 py-3">
              <i className="ri-shield-check-line text-[#4CAF50] text-xl" />
              <span className="text-[#1A2B4A] text-sm font-semibold">
                2004'ten bu yana 33+ tamamlanan proje teslim edildi
              </span>
            </div>
          </div>

          {/* Right – Timeline */}
          <div className="lg:w-7/12 w-full">
            {/* Desktop horizontal timeline */}
            <div className="hidden md:block">
              <div className="relative pt-10">
                {/* Line */}
                <div className="absolute top-[52px] left-0 right-0 h-0.5 bg-gradient-to-r from-[#4CAF50]/30 via-[#4CAF50] to-[#4CAF50]" />

                <div className="grid grid-cols-4 gap-4">
                  {timelineItems.map((item, i) => (
                    <div key={i} className="relative flex flex-col items-center text-center">
                      {/* Year */}
                      <div className="text-[#1A2B4A] font-bold text-lg mb-3">{item.year}</div>

                      {/* Dot */}
                      <div
                        className={`relative z-10 rounded-full border-2 border-[#4CAF50] flex items-center justify-center mb-4 ${
                          item.active
                            ? "w-5 h-5 bg-[#4CAF50] shadow-[0_0_0_6px_rgba(76,175,80,0.2)]"
                            : "w-4 h-4 bg-white"
                        }`}
                      />

                      {/* Content */}
                      <div className="bg-[#F8F9FA] rounded-xl p-4 w-full">
                        <div className="text-[#1A2B4A] font-semibold text-sm mb-1">{item.title}</div>
                        <div className="text-[#718096] text-xs leading-relaxed">{item.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Mobile vertical timeline */}
            <div className="md:hidden flex flex-col gap-0">
              {timelineItems.map((item, i) => (
                <div key={i} className="flex gap-4">
                  <div className="flex flex-col items-center">
                    <div
                      className={`rounded-full border-2 border-[#4CAF50] flex-shrink-0 ${
                        item.active ? "w-4 h-4 bg-[#4CAF50]" : "w-3 h-3 bg-white mt-0.5"
                      }`}
                    />
                    {i < timelineItems.length - 1 && (
                      <div className="w-0.5 flex-1 bg-[#4CAF50]/30 my-1" />
                    )}
                  </div>
                  <div className="pb-8">
                    <div className="text-[#4CAF50] font-bold text-sm mb-0.5">{item.year}</div>
                    <div className="text-[#1A2B4A] font-semibold text-sm mb-1">{item.title}</div>
                    <div className="text-[#718096] text-xs leading-relaxed">{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Image below timeline */}
            <div className="mt-10 rounded-2xl overflow-hidden h-56 md:h-64">
              <img
                src="/images/about.jpg"
                alt="Güvenli Dizayn Ekibi"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
